import { render } from "./AgendModal.vue?vue&type=template&id=36dc3af4&scoped=true"
import script from "./AgendModal.vue?vue&type=script&lang=js"
export * from "./AgendModal.vue?vue&type=script&lang=js"

import "./AgendModal.vue?vue&type=style&index=0&id=36dc3af4&scoped=true&lang=css"
import "./AgendModal.vue?vue&type=style&index=1&id=36dc3af4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36dc3af4"]])

export default __exports__